import axios from "axios";
import { BASE_URL } from "../../_constants/urlConstants";
import { delay, getUUID } from "../../_utils/generalUtils";
import raiseError from "../raiseError";
import qs from "qs";
import { QMS } from "../../_constants/actionConstants";

const fakeIssueStages = {
  1: {
    issueStageId: 1,
    issueId: 1,
    cmtStageId: 3,
    ownerTeamId: 1,
    isCurrent: false,
    startedOn: new Date("2/1/2023").toISOString(),
    startedByQmsUserId: 1,
    isCompleted: true,
    completedOn: new Date("2/4/2023").toISOString(),
    posts: [
      {
        issueStagePostId: 1,
        issueStageId: 1,
        bodyText:
          "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore.",
        isPrivate: true,
        postedOn: new Date("3/1/23").toISOString(),
        postedByQmsUserId: 1,
        inResponseTo: null,
        upvotes: 0,
      },
      {
        issueStagePostId: 2,
        issueStageId: 1,
        bodyText:
          "Do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        isPrivate: true,
        postedOn: new Date("3/1/23").toISOString(),
        postedByQmsUserId: 3,
        inResponseTo: null,
        upvotes: 0,
      },
      {
        issueStagePostId: 3,
        issueStageId: 1,
        bodyText:
          "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        isPrivate: true,
        postedOn: new Date("3/1/23").toISOString(),
        postedByQmsUserId: 2,
        inResponseTo: null,
        upvotes: 0,
      },
      {
        issueStagePostId: 4,
        issueStageId: 1,
        bodyText:
          "Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
        isPrivate: true,
        postedOn: new Date("3/2/23").toISOString(),
        postedByQmsUserId: 1,
        inResponseTo: 2,
        upvotes: 0,
      },
      {
        issueStagePostId: 3,
        issueStageId: 1,
        bodyText: "Sunt in culpa qui officia deserunt mollit anim id est laborum.",
        isPrivate: true,
        postedOn: new Date("3/4/23").toISOString(),
        postedByQmsUserId: 2,
        inResponseTo: 2,
        upvotes: 0,
      },
    ],
    attachments: [],
  },
  2: {
    issueStageId: 2,
    issueId: 1,
    cmtStageId: 4,
    ownerTeamId: 1,
    isCurrent: true,
    startedOn: new Date("2/10/2023").toISOString(),
    startedByQmsUserId: 2,
    isCompleted: false,
    completedOn: null,
    posts: [],
    attachments: [],
  },
};

const logError = (e) => console.error("ProDMS/QMS: Request failed with error:", e);

const cmtIssueStageActions = {
  add: (newIssueStageData) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE_STAGE.ADD });
    const apiEndpoint = BASE_URL + "/api/qms/IssueStage";
    try {
      const res = await axios.post(apiEndpoint, newIssueStageData);
      dispatch({
        type: QMS.ISSUE_STAGE.ADD_FULFILLED,
        issueId: newIssueStageData.issueId,
        issueStage: res.data,
      });
      return res.data.issueStageId;
    } catch (e) {
      dispatch({ type: QMS.ISSUE_STAGE.ADD_REJECTED });
      logError(e);
    }
  },
  update: (issueId) => async (dispatch, getState) => {
    dispatch({ type: QMS.ISSUE_STAGE.UPDATE });
    const apiEndpoint = BASE_URL + "/api/qms/IssueStage";
    try {
      const updatedIssueStage = getState().qms.openIssueStages[issueId] || null;
      const res = await axios.put(apiEndpoint, updatedIssueStage);
      dispatch({
        type: QMS.ISSUE_STAGE.UPDATE_FULFILLED,
        issueId,
        issueStage: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.ISSUE_STAGE.UPDATE_REJECTED });
      logError(e);
    }
  },
  start: (issueId, issueStageId, startedOn) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE_STAGE.UPDATE });
    const apiEndpoint = `${BASE_URL}/api/qms/IssueStage/Start/${issueStageId}/${startedOn}`;
    try {
      const res = await axios.patch(apiEndpoint);
      dispatch({
        type: QMS.ISSUE_STAGE.UPDATE_FULFILLED,
        issueId,
        issueStage: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.ISSUE_STAGE.UPDATE_REJECTED });
      logError(e);
    }
  },
  markCompleted: (issueId, issueStageId, completedOn) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE_STAGE.UPDATE });
    const apiEndpoint = `${BASE_URL}/api/qms/IssueStage/MarkCompleted/${issueStageId}/${completedOn}`;
    try {
      const res = await axios.patch(apiEndpoint);
      dispatch({
        type: QMS.ISSUE_STAGE.UPDATE_FULFILLED,
        issueId,
        issueStage: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.ISSUE_STAGE.UPDATE_REJECTED });
      logError(e);
    }
  },
  remove: (issueId, issueStageId) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE_STAGE.REMOVE });
    const apiEndpoint = BASE_URL + "/api/qms/IssueStage/" + issueStageId;
    try {
      await axios.delete(apiEndpoint);
      dispatch({
        type: QMS.ISSUE_STAGE.REMOVE_FULFILLED,
        issueId,
      });
    } catch (e) {
      dispatch({ type: QMS.ISSUE_STAGE.REMOVE_REJECTED });
      logError(e);
    }
  },
  getFake: (issueId, issueStageId) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE_STAGE.FETCH });

    if (!issueId || !(issueStageId in fakeIssueStages))
      dispatch({ type: QMS.ISSUE_STAGE.FETCH_REJECTED });

    console.log("Fetching mock issueStage for issueStageId=", issueStageId);
    await delay(1300);
    dispatch({
      type: QMS.ISSUE_STAGE.FETCH_FULFILLED,
      issueId,
      issueStage: fakeIssueStages[issueStageId],
    });
  },
  get: (issueId, issueStageId) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE_STAGE.FETCH });
    const apiEndpoint = BASE_URL + "/api/qms/IssueStage/" + issueStageId;
    try {
      const res = await axios.get(apiEndpoint);
      console.log("updated iss=", res.data);
      dispatch({
        type: QMS.ISSUE_STAGE.FETCH_FULFILLED,
        issueId,
        issueStage: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.ISSUE_STAGE.FETCH_REJECTED });
      logError(e);
    }
  },
  addPost: (issueId, issueStageId, newIssueStagePostData) => async (dispatch) => {
    dispatch({ type: QMS.ISSUE_STAGE.ADD_POST });
    const apiEndpoint = BASE_URL + "/api/qms/IssueStage/Post/" + issueStageId;
    try {
      const res = await axios.post(apiEndpoint, newIssueStagePostData);
      dispatch({
        type: QMS.ISSUE_STAGE.ADD_POST_FULFILLED,
        issueId,
        issueStage: res.data,
      });
    } catch (e) {
      dispatch({ type: QMS.ISSUE_STAGE.ADD_POST_REJECTED });
      logError(e);
    }
  },
  addPostFake: (issueId, newIssueStagePostData) => async (dispatch, getState) => {
    dispatch({ type: QMS.ISSUE_STAGE.ADD_POST });

    delay(300);

    if (!issueId || !(issueId in fakeIssueStages))
      dispatch({ type: QMS.ISSUE_STAGE.ADD_POST_REJECTED });

    const iss =
      issueId in getState().qms.openIssueStages
        ? getState().qms.openIssueStages[issueId]
        : null;
    if (!iss) dispatch({ type: QMS.ISSUE_STAGE.ADD_POST_REJECTED });

    const newIspId =
      Math.max(...(iss.posts || []).map((isp) => isp.issueStagePostId)) + 1;
    const newIss = {
      ...iss,
      posts: [
        ...(iss.posts || []),
        { ...newIssueStagePostData, issueStagePostId: newIspId },
      ],
    };

    dispatch({
      type: QMS.ISSUE_STAGE.ADD_POST_FULFILLED,
      issueId,
      issueStage: newIss,
    });
  },
  addPostUpvote:
    (issueId, issueStageId, issueStagePostId, voteByQmsUserId) => async (dispatch) => {
      dispatch({ type: QMS.ISSUE_STAGE.ADD_POST_UPVOTE });
      const apiEndpoint =
        BASE_URL +
        `/api/qms/IssueStage/Post/Up/${issueStageId}/${issueStagePostId}/${voteByQmsUserId}`;
      try {
        const res = await axios.patch(apiEndpoint);
        dispatch({
          type: QMS.ISSUE_STAGE.ADD_POST_UPVOTE_FULFILLED,
          issueId,
          issueStage: res.data,
        });
      } catch (e) {
        dispatch({ type: QMS.ISSUE_STAGE.ADD_POST_UPVOTE_REJECTED });
        logError(e);
      }
    },
  addPostDownvote:
    (issueId, issueStageId, issueStagePostId, voteByQmsUserId) => async (dispatch) => {
      dispatch({ type: QMS.ISSUE_STAGE.ADD_POST_DOWNVOTE });
      const apiEndpoint =
        BASE_URL +
        `/api/qms/IssueStage/Post/Down/${issueStageId}/${issueStagePostId}/${voteByQmsUserId}`;
      try {
        const res = await axios.patch(apiEndpoint);
        dispatch({
          type: QMS.ISSUE_STAGE.ADD_POST_DOWNVOTE_FULFILLED,
          issueId,
          issueStage: res.data,
        });
      } catch (e) {
        dispatch({ type: QMS.ISSUE_STAGE.ADD_POST_DOWNVOTE_REJECTED });
        logError(e);
      }
    },
  downloadFile: (issueStageAttachmentId, filename) => async (dispatch) => {
    dispatch({ type: QMS.FILE_REQUEST });
    const apiEndpoint = BASE_URL + "/api/qms/IssueStage/File/" + issueStageAttachmentId;
    try {
      const res = await axios.get(apiEndpoint, {
        responseType: "blob",
      });
      if (res.data) {
        const fileBlob = new Blob([res.data]);

        const url = URL.createObjectURL(fileBlob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
        dispatch({ type: QMS.FILE_REQUEST_FULFILLED });
      }
      return;
    } catch (err) {
      dispatch({ type: QMS.FILE_REQUEST_REJECTED });
      logError(err);
    }
  },
};

export default cmtIssueStageActions;
